var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.jobs),function(job){return _c('job-state-chip',{key:job.id,attrs:{"job":job}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }